
<template>
    <input-published-form
        v-model="formSlug"
        manage-text="Hantera formulär"
        reload-text="Ladda om tillgängliga formulär"
    />
</template>
<script>
import InputPublishedForm from '../../../forms/inputPublishedForm.vue';

export default {
    components: {
        InputPublishedForm,
    },
    props: {
        modelValue: {},
        layout: {
            type: String,
            default: 'full'
        }
    },
    emits: [
        'update:modelValue'
    ],
    data() {
        return {
            formSlug: null
        };
    },
    mounted() {
        this.captureModelValue();
    },
    watch: {
        modelValue() {
            this.captureModelValue();
        },
        formSlug() {
            this.$emit('update:modelValue', {
                form_slug: this.formSlug
            });
        }
    },
    methods: {
        captureModelValue() {
            const newValue = (this.modelValue ? this.modelValue.form_slug : null);
            if (this.formSlug === newValue) { return; }

            this.formSlug = newValue;
        }
    },
}
</script>
